import { Question } from "../../interfaces/purchase-order.interface";
import { QuestionType } from "../../enums/question-type.enum";

export class RepuveQuestion {
  public static question_invoice_main: Question[] = [
    {
      type: "radio",
      question: "¿La información del documento corresponde a un reporte del REPUVE?",
      formatted_question: "¿La información del documento corresponde a un reporte del <b>REPUVE</b>?",
      control: "file_correct",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "Carga un archivo en formato PDF del reporte generado en la página del REPUVE",
          },
        },
      ],
      page: 1,
    },
    {
      type: "checkbox",
      question: "Marca los datos vehículares que aparecen en el reporte:",
      formatted_question: "Marca los <b>datos vehículares</b> que aparecen en el reporte:",
      additional_information: "Número de identificación vehicular (NIV)",
      control: "identification_number",
      label: "",
      answer: undefined,

      page: 1,
    },
    {
      type: "checkbox",
      additional_information: "Modelo",
      control: "car_model",
      label: "",
      answer: undefined,

      page: 1,
    },
    {
      type: "select",
      question: "Selecciona las placas del documento",
      control: "plates_repuve",
      options: [],
      page: 2,
    },
    {
      type: "radio",
      question: "¿El auto tiene reporte de robo?",
      control: "robbery_report",
      options: [
        { label: "No", value: { value: false, incident: false } },
        {
          label: "Sí",
          value: {
            value: true,
            incident: true,
            incident_text: "Fin del proceso. Este auto no puede seguir adelante por políticas de Nexu.",
          },
        },
      ],
      page: 2,
    },
  ];

  public static question_invoice_partial: Question[] = [
    {
      type: "radio",
      question: "¿La información del documento corresponde a un reporte del REPUVE?",
      formatted_question: "¿La información del documento corresponde a un reporte del <b>REPUVE</b>?",
      control: "file_correct",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "Carga un archivo en formato PDF del reporte generado en la página del REPUVE",
          },
        },
      ],
      page: 1,
    },
    {
      type: "checkbox",
      question: "Marca los datos vehículares que aparecen en el reporte:",
      formatted_question: "Marca los <b>datos vehículares</b> que aparecen en el reporte:",
      additional_information: "Número de identificación vehicular (NIV)",
      control: "identification_number",
      label: "",
      answer: undefined,

      page: 1,
    },
    {
      type: "checkbox",
      additional_information: "Modelo",
      control: "car_model",
      label: "",
      answer: undefined,

      page: 1,
    },
    {
      type: "radio",
      question: "¿El auto tiene reporte de robo?",
      control: "robbery_report",
      options: [
        { label: "No", value: { value: false, incident: false } },
        {
          label: "Sí",
          value: {
            value: true,
            incident: true,
            incident_text: "Fin del proceso. Este auto no puede seguir adelante por políticas de Nexu.",
          },
        },
      ],
      page: 2,
    },
  ];

  public static response_incidents_plates = {
    label: "No encontré la placa",
    value: {
      value: "No encontré la placa",
      incident: true,
      incident_text: "Las placas no fueron registradas en las tenencias.",
    },
  };
}
